export const isValidUrl = (value: unknown): boolean => {
  if (typeof value === "string") {
    try {
      new URL(value);
      return true;
    } catch {
      return false;
    }
  }

  return value instanceof URL;
};

export const isFile = (value: unknown) => value instanceof File;

export const isImageFile = (value: unknown) =>
  isFile(value) &&
  ["image/jpeg", "image/png", "image/bmp", "image/webp"].includes(value.type);
